import { atom } from 'recoil';

export const CurrentTitle = atom({
  key: 'CurrentTitle',
  default: '',
});
